﻿import controller from '../../../../Resources/Scripts/_Shared/Controller';
import { paramsToObject } from '../../../../Resources/Scripts/_Shared/history'
import { openOverlay } from '../../_Shared/Scripts/LandlordPermitOverlay'

function landlordPermitsPage(context) {
  const overlayContext = context.querySelector("[data-controller=landlord-permit-overlay]");

  function init() {
    context.addEventListener('click', async function (event) {
      if (event.target.dataset.createPermit) {
        event.preventDefault();

        const heading = event.target.dataset.heading;

        //Open create permit overlay
        openOverlay(overlayContext, { heading, hideLoader: true });
      } else if (event.target.dataset.editPermit) {
        event.preventDefault();

        const heading = event.target.dataset.heading;
        const permitId = event.target.dataset.permitId;

        //Open create permit overlay
        openOverlay(overlayContext, { heading, permitId, hideLoader: true });
      }
    });

    context.addEventListener('click', async function (event) {
      if (event.target.dataset.editPermit) {
        event.preventDefault();

        const heading = event.target.dataset.heading;
        const subHeading = event.target.dataset.subHeading;
        const permitId = event.target.dataset.permitId;

        openOverlay(overlayContext, { heading, subHeading, permitId, hideLoader: true });

        const urlParams = new URLSearchParams(window.location.search);
        urlParams.set('permitId', permitId);

        const newUrl = window.location.origin + window.location.pathname + '?' + urlParams.toString();
        history.replaceState(paramsToObject(urlParams), document.title, newUrl);
      }
    });

    //If url contains permiId paramater - show overlay
    const permitIdQuery = new URLSearchParams(window.location.search).get('permitId');

    if (permitIdQuery) {
      const permitListItem = context.querySelector(`.landlordpermitspage__list li a[data-permit-id="${permitIdQuery}"]`);

      if (permitListItem) {
        const heading = permitListItem.dataset.heading;
        const subHeading = permitListItem.dataset.subHeading;
        const permitId = permitListItem.dataset.permitId;

        //Open season ticket overlay
        openOverlay(overlayContext, { heading, subHeading, permitId, hideLoader: true });
      }
    }
  }

  return {
    init
  };
}

controller.add('landlord-permits-page', landlordPermitsPage);